<app-input-search
    *ngIf="getListLength() > 5"
    [label]="dictionary.input_search_placeholder"
    [showToggleArrowButtons]="false"
    [positionIcon]="'left'"
    (searchEvent)="filterList($event)"
    (inputEvent)="searchStr = $event"
>
</app-input-search>
<mat-selection-list #list cdkScrollable customScroll overflowY="true" [multiple]="isMultiple">
    <ng-container *ngFor="let item of optionList$ | async; let index = index">
        <mat-list-option
            [matTooltip]="item.name"
            (click)="isMultiple ? selectedItems.toggle(item) : selectionEvent.emit(item)"
            (dblclick)="isMultiple ? selectionEvent.emit(item) : null"
            #listOption
            [value]="item.id"
        >
            <mat-checkbox
                *ngIf="isMultiple"
                [checked]="selectedItems.isSelected(item)"
                [disableRipple]="true"
                class="!mr-[8px]"
            ></mat-checkbox>
            <mat-label [highlight]="searchStr" [text]="item.name"> </mat-label>&nbsp;
        </mat-list-option>
    </ng-container>
</mat-selection-list>
